define('modules/htmlad/templates/favorites/favorite_model',['backbone',
'_',

'session'
], function (Backbone, _, session) {
'use strict';
var Model = Backbone.Model.extend({
  defaults: {},

  initialize: function (data) {

  },
  parse: function (response, options) {
    return response;
  },
  url: function() {
    return session.get('apiUrl') + 'htmltemplates/isFavorite';
  }
});

return Model;
});
  
